export default [
  {
    path: '/balance-report-sport99',
    name: 'balance-report-sport99',
    component: () => import('@/views/balanceReportSport99/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.balanceReportSport99',
      resource: 'balance-report-sport99',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listBalanceReportSport99',
          active: true,
        },
      ],
    },
  },
]
